import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { defaultInsightView, isInsightView } from './helpers/view.helper';

export const insightsRoutesGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);

  const view = route.params['view'];

  if (!isInsightView(view)) {
    router.navigate([`/insights/${defaultInsightView}`]);
    return false;
  }

  return true;
};
